import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex column min-height io-mfe-ig-search-table-pane full-width" }

import {onMounted} from 'vue';
import ProcedureTableHeader from 'components/search/procedure/ProcedureTableHeader.vue';
import ProcedureTable from 'components/search/procedure/ProcedureTable.vue';
import ProcedureTableFooter from 'components/search/procedure/ProcedureTableFooter.vue';
import { useSearchStore } from 'stores/search-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchTablePane',
  setup(__props) {

onMounted(() => {
  // fetch initial PcsSections
  useSearchStore().fetchPcsSections();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ProcedureTableHeader),
    _createVNode(ProcedureTable),
    _createVNode(ProcedureTableFooter)
  ]))
}
}

})